import { joinValidStrings } from './string';

const formatVolume = volume => (volume ? `vol. ${volume}` : '');
const formatIssue = issue => (issue ? `issue ${issue}` : '');
export const formatYear = year => (year ? `(${year})` : '');
const formatPages = (pages) => {
  if (!pages) return '';
  if (pages.match(/[-~]/)) return `pp. ${pages}`;
  return `p. ${pages}`;
};

// 'Source, vol. X, issue Y'
const formatPublicationVersion = ({ source, volume, issue }) => (
  source ? joinValidStrings([source, formatVolume(volume), formatIssue(issue)], ', ') : ''
);

// 'Source, vol. X, issue Y (Year) pp. A-B'
export const formatPublication = ({
  source, volume, issue, year, pages
}) => (
  source ? joinValidStrings([
    formatPublicationVersion({ source, volume, issue }),
    formatYear(year),
    formatPages(pages)
  ], ' ') : ''
);



// WEBPACK FOOTER //
// ./src/universal/ui/utils/format-publication-data.js